// ============================================================================
// WidgetShell — common card wrapper used by every executive widget.
// ============================================================================
import React from 'react';
import IconSystem from 'icon-collection/icon-systems';

interface Props {
  title: string;
  subtitle?: string;
  /** Optional right-side action (e.g., a drill button). */
  action?: React.ReactNode;
  /** Set to true to remove inner padding (useful for full-bleed charts). */
  flush?: boolean;
  children: React.ReactNode;
}

const WidgetShell: React.FC<Props> = ({ title, subtitle, action, flush, children }) => (
  <div className="exec-widget">
    <div className="exec-widget-header">
      <div>
        <div className="exec-widget-title">{title}</div>
        {subtitle && <div className="exec-widget-subtitle">{subtitle}</div>}
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
        {action}
        <button className="exec-widget-info-btn" title="Drill into this metric">
          <IconSystem.search size={14} />
        </button>
      </div>
    </div>
    <div className={flush ? 'exec-widget-body-flush' : 'exec-widget-body'}>
      {children}
    </div>
  </div>
);

export default WidgetShell;
